// TODO: Add fundamental rule-types here
// TODO: Add Min/Max rule-types here
export const RULETYPE_PREPACK = 'RULETYPE_PREPACK';

// Pre-Pack units of measure
export const PREPACK_MEASURE_EACH = 'EACH';
